import { Box, Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { EventType } from '@/components/ui/features/presentation/PresentationEventTypes/components/EventType';

export const PresentationEventTypes = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgImage="linear-gradient(180deg, rgba(170, 138, 247, 0.75) 0%, rgba(170, 138, 247, 0.00) 100%)"
      bgRepeat="no-repeat"
      pt={12}
      pb={12}
    >
      <Container maxW="1100px">
        <Text textAlign="center" fontFamily="heading" fontSize="3xl">
          {t('newEventPage.conferenceFormatTitleOne')}{' '}
          <Text fontFamily="heading" as="span" fontWeight="bold">
            {t('newEventPage.conferenceFormatTitleTwo')}
          </Text>
        </Text>
        <Text mt={4} textAlign="center">
          {t('newEventPage.conferenceFormatDescription')}
        </Text>

        <Flex
          flexDirection={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="flex-start"
          mt={8}
          gap={10}
        >
          <EventType
            title={t('newEventPage.conferenceFormats.0.heading')}
            buttonText={t('newEventPage.conferenceFormats.0.buttonText')}
            description={t('newEventPage.conferenceFormats.0.description')}
            buttonLink="/events/virtual-events"
          />
          <EventType
            title={t('newEventPage.conferenceFormats.1.heading')}
            buttonText={t('newEventPage.conferenceFormats.1.buttonText')}
            description={t('newEventPage.conferenceFormats.1.description')}
            buttonLink="/events/hybrid-events"
          />
          <EventType
            title={t('newEventPage.conferenceFormats.2.heading')}
            buttonText={t('newEventPage.conferenceFormats.2.buttonText')}
            description={t('newEventPage.conferenceFormats.2.description')}
            buttonLink="/events/in-person-events"
          />
        </Flex>
      </Container>
    </Box>
  );
};
